import React from 'react';

const content = {
  description: (
    <>
      Xerion to
      {' '}
      pierwsza prywatna szkoła złotnictwa, założona w
      {' '}
      2013 roku
      w
      {' '}
      Krakowie. W
      {' '}
      ramach naszych kursów zdobędziesz niezbędne umiejętności
      potrzebne do
      {' '}
      realizacji autorskich projektów.
      Poznasz materiały, narzędzia, techniki oraz historię złotnictwa.
      <br />
      <br />
    </>
  ),

  coursesLinkText: 'Więcej informacji o naszej ofercie znajdziesz w zakładce KURSY',

  babble: (
    <>
      Zajęcia pozwalają odkryć przyjemność płynącą
      z
      {' '}
      pracy manualnej.

      Nasza pracownia to
      {' '}
      doskonałe miejsce
      dla kreatywnych, ceniących rzemiosło osób.
      <br />
      <br />
      <br />

      Kursy odbywają się w
      {' '}
      kompleksowo wyposażonej
      pracowni, w
      {' '}
      skład której wchodzi:
      <br />
      <br />

      - duża sala
      <br />
      - mała sala
      <br />
      - sala obrączek
      <br />
      - narzędziownia
      <br />
      - miejsce do wypoczynku
      <br />
      <br />
      <br />
    </>
  ),

  moreBabble: (
    <>
      Szkoła to miejsce pracy, spotkań artystów i
      {' '}
      każdego, kto chce rozwijać swoje twórcze umiejętności.
      Jesteśmy otwarci zarówno dla osób początkujących, jak i
      {' '}
      zaawansowanych.
      {/* eslint-disable-next-line max-len */}
      Chętnie dzielimy się zdobytą wiedzą prowadząc kursy jubilerskie oraz warsztaty robienia obrączek ślubnych.
    </>
  ),

  smallRoom: 'mała sala',
  bigRoom: 'duża sala',
  kitchen: 'strefa relaksu',
};

export default content;
